
    import './styles.scoped.css';
    export default {
  "drawer-displayed": "awsui_drawer-displayed_1lh3u_1yevz_103",
  "drawer-content": "awsui_drawer-content_1lh3u_1yevz_107"
};
  